import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BuildingBaseData } from '@artemis-software/wr-api';
import { AbstractFormControl } from '../abstract-form-control';

@Component({
  standalone: false,
  selector: 'wr-insurance-company-select',
  templateUrl: './insurance-company-select.component.html',
  styleUrls: ['./insurance-company-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InsuranceCompanySelectComponent),
      multi: true,
    },
  ],
})
export class InsuranceCompanySelectComponent extends AbstractFormControl<BuildingBaseData.InsuranceCompanyEnum> {

    readonly InsuranceCompany = Object.values(BuildingBaseData.InsuranceCompanyEnum);

    @Input()
    showEmptyOption = false;
}
